import InteractionEvents from './InteractionEvents';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  __init__: [ 'interactionEvents' ],
  interactionEvents: [ 'type', InteractionEvents ]
};